import clsx from 'clsx';
import { MdCalendarToday } from 'react-icons/md';
import DatePickerModal from '@/components/DatePickerModal';

interface CandidatesDatetimeFieldForFormProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

/**
 * 候補者登録画面専用の日時選択コンポーネント
 * DatePickerModalを使用して、文字列⇔Date型の変換を処理
 */
export default function CandidatesDatetimeFieldForForm({
  value,
  onChange,
  placeholder = '日時を選択',
  className = '',
}: CandidatesDatetimeFieldForFormProps) {
  // 表示用フォーマット（YYYY/MM/DD HH:MM）
  const formatDisplayDate = (dateString: string): string => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}/${month}/${day} ${hours}:${minutes}`;
  };

  const displayText = value ? formatDisplayDate(value) : placeholder;

  return (
    <DatePickerModal value={value} onChange={onChange} type="datetime" className={className}>
      <button
        type="button"
        className={clsx(
          'flex h-[42px] w-full items-center rounded border border-solid border-border bg-white px-3 focus:border-2 focus:border-primary focus-visible:outline-hidden',
          className
        )}
      >
        <span className={clsx('text-sm', !value && 'text-gray-500')}>{displayText}</span>
        <MdCalendarToday className="ml-auto size-5 text-gray-400" />
      </button>
    </DatePickerModal>
  );
}
